module.exports = __webpack_public_path__ + "b10f9072e80633a2081ac88ea2e59383.ttf";